import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';

type BAckButtonProps = {
  onClick?: (() => void) | null;
};

export const BackButton: React.FC<BAckButtonProps> = ({onClick}) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onClick={() => {
        if (onClick) {
          onClick();
          return;
        }
        navigate(-1);
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        color: isHovered ? '#daff00' : '#fff',
        transition: 'color 0.2s ease',
        padding: '10px 0',
      }}>
      <span style={{fontSize: '1.5rem', marginRight: '8px'}}>←</span>
      <span style={{fontWeight: 600, fontSize: '1rem'}}>Back</span>
    </button>
  );
};
